/**
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 * Sectors - Rusenge 
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 */
module.exports = {
  "Bunge": ["Bunge", "Jali", "Nyanzoga", "Toraniro"],
  "Cyuna": ["Cyuna", "Kiramutse", "Remera", "Uwamuhizi"],
  "Gikunzi": ["Jali", "Kibu", "Munanira", "Rwabujagi"],
  "Mariba": ["Gihango", "Kabuye", "Miko", "Rasaniro"],
  "Raranzige": ["Akabacura", "Gasave", "Karimba", "Ntanda", "Nyamugari"],
  "Rusenge": ["Kabacuzi", "Kamusindi", "Kavumu", "Runyinya"]
};